import { z } from 'zod';

import { idSchema } from './id';
import { skillShortSchema } from './skill';

import type { Mutation } from './common';

type SkillIdsField = {
    readonly skillIds: readonly string[];
};

export const projectHistoryItemSchema = z.object({
    id: z.string(),
    companyName: z.string(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
    description: z.string().optional(),
    location: z.string().optional(),
    ongoing: z.boolean().optional(),
    projectTitle: z.string(),
    skills: skillShortSchema.array().optional(),
});
export const projectHistoryItemArraySchema = projectHistoryItemSchema.array();

export type ProjectHistoryItem = z.infer<typeof projectHistoryItemSchema>;

export const projectHistoryCreationSchema = projectHistoryItemSchema
    .omit({ id: true, skills: true })
    .extend({ skillIds: idSchema.array().optional() });
export type ProjectHistoryCreation = z.infer<typeof projectHistoryCreationSchema>;

export type ProjectHistoryMutation = Mutation<ProjectHistoryItem> &
    Pick<ProjectHistoryItem, 'companyName' | 'id' | 'projectTitle'> &
    SkillIdsField;
